module.exports = __webpack_public_path__ + "img/twitter.34070225.png";